import { type FieldErrors, type UseFormRegister } from 'react-hook-form'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export interface CustomerLimitsFormValues {
  maxDialPerSecond: number
  maxActiveConferences: number
  maxSimultaneousCalls: number
  ratio: number
}

// Props accept specific types but can be passed wider form types via type assertion
interface CustomerLimitsFormProps {
  register: UseFormRegister<CustomerLimitsFormValues>
  errors: FieldErrors<CustomerLimitsFormValues>
}

export function CustomerLimitsForm({ register, errors }: CustomerLimitsFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Customer Limits</CardTitle>
        <CardDescription>
          Set maximum values for campaign settings that customers can configure
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="maxDialPerSecond">Max Dial Per Second</Label>
            <Input
              {...register('maxDialPerSecond', {
                valueAsNumber: true,
                min: { value: 1, message: 'Must be at least 1' },
              })}
              id="maxDialPerSecond"
              type="number"
              min="1"
              className={errors.maxDialPerSecond ? 'border-red-500' : ''}
            />
            {errors.maxDialPerSecond && (
              <p className="text-detail text-red-500">{errors.maxDialPerSecond.message}</p>
            )}
          </div>
          <div className="space-y-2">
            <Label htmlFor="maxActiveConferences">Max Active Conferences</Label>
            <Input
              {...register('maxActiveConferences', {
                valueAsNumber: true,
                min: { value: 1, message: 'Must be at least 1' },
              })}
              id="maxActiveConferences"
              type="number"
              min="1"
              className={errors.maxActiveConferences ? 'border-red-500' : ''}
            />
            {errors.maxActiveConferences && (
              <p className="text-detail text-red-500">{errors.maxActiveConferences.message}</p>
            )}
          </div>
          <div className="space-y-2">
            <Label htmlFor="maxSimultaneousCalls">Max Simultaneous Calls</Label>
            <Input
              {...register('maxSimultaneousCalls', {
                valueAsNumber: true,
                min: { value: 1, message: 'Must be at least 1' },
              })}
              id="maxSimultaneousCalls"
              type="number"
              min="1"
              className={errors.maxSimultaneousCalls ? 'border-red-500' : ''}
            />
            {errors.maxSimultaneousCalls && (
              <p className="text-detail text-red-500">{errors.maxSimultaneousCalls.message}</p>
            )}
          </div>
          <div className="space-y-2">
            <Label htmlFor="ratio">Ratio</Label>
            <Input
              {...register('ratio', {
                valueAsNumber: true,
                min: { value: 1, message: 'Must be at least 1' },
              })}
              id="ratio"
              type="number"
              min="1"
              step="1"
              className={errors.ratio ? 'border-red-500' : ''}
            />
            {errors.ratio && (
              <p className="text-detail text-red-500">{errors.ratio.message}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
